import React from 'react';
import { Form } from 'antd';
import { usePermissions } from '../../hooks/usePermissions';

/**
 * PermissionFormItem:
 * - Renders form item only if user can view the field (field-level)
 * - Disables input if user cannot edit the field (field-level)
 * 
 * @param {Object} props
 * @param {string} props.module Module name
 * @param {string} props.name Field name
 * @param {string} props.label Label text
 * @param {React.ReactNode} props.children
 * @param {any} props.rest Other Form.Item props
 */
const PermissionFormItem = ({
  module,
  name,
  label,
  children,
  ...rest
}) => {
  const { canViewField, canEditField } = usePermissions();

  const hasView = canViewField(module, name);
  const hasEdit = canEditField(module, name);

  if (!hasView) return null;

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      const disabled = !hasEdit || child.props.disabled;
      return React.cloneElement(child, { disabled });
    }
    return child;
  });

  return (
    <Form.Item {...rest} name={name} label={label}>
      {childrenWithProps}
    </Form.Item>
  );
};

export default PermissionFormItem;
